import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const FreteMachineLearning = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesData = [
    {
      id: 1,
      title: 'solutionsData_page.cases.items.delfos.title',
      description: 'solutionsData_page.cases.items.delfos.description',
      icon: '',
      url: 'delfos',
    },
    {
      id: 2,
      title: 'solutionsData_page.cases.items.fretesAnalytics.title',
      description: 'solutionsData_page.cases.items.fretesAnalytics.description',
      icon: '',
      url: 'fretes-analytics',
    },
    {
      id: 3,
      title: 'solutionsData_page.cases.items.kanban.title',
      description: 'solutionsData_page.cases.items.kanban.description',
      icon: '',
      url: 'kanban',
    },
    {
      id: 5,
      title: 'solutionsData_page.cases.items.fretesInsights.title',
      description: 'solutionsData_page.cases.items.fretesInsights.description',
      icon: '',
      url: 'fretes-insights',
    },
    {
      id: 6,
      title: 'solutionsData_page.cases.items.integraSapIbp.title',
      description: 'solutionsData_page.cases.items.integraSapIbp.description',
      icon: '',
      url: 'integra-SAP-IBP',
    },
    {
      id: 7,
      title: 'solutionsData_page.cases.items.estruturaDadosHorizontal.title',
      description: 'solutionsData_page.cases.items.estruturaDadosHorizontal.description',
      icon: '',
      url: 'estrutura-de-dados-horizontal',
    },
    {
      id: 8,
      title: 'solutionsData_page.cases.items.qualidadeGovernanca.title',
      description: 'solutionsData_page.cases.items.qualidadeGovernanca.description',
      icon: '',
      url: 'qualidade-e-governanca',
    },
    {
      id: 9,
      title: 'solutionsData_page.cases.items.migracaoDatabricks.title',
      description: 'solutionsData_page.cases.items.migracaoDatabricks.description',
      icon: '',
      url: 'migracao-de-dados-databricks',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('solutionsData_page.cases.cta')
    const caseTitle = t(caseItem.title)

    trackCtaClick({
      cta_name: 'data_case_related_case_click',
      cta_location: 'data_case',
      page_name: 'fretes_machine_learning',
      case_title: caseTitle,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('freteMachineLearning_page.header.title')}</h2>
        </div>
        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase2.png"
            alt={t('freteMachineLearning_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">
            {t('freteMachineLearning_page.sections.challenge.title')}
          </h3>
          <ul>
            <li>{t('freteMachineLearning_page.sections.challenge.items.item1')}</li>
            <li>{t('freteMachineLearning_page.sections.challenge.items.item2')}</li>
            <li>{t('freteMachineLearning_page.sections.challenge.items.item3')}</li>
          </ul>
          <hr />
          <h3>{t('freteMachineLearning_page.sections.approach.title')}</h3>
          <ul>
            <li>{t('freteMachineLearning_page.sections.approach.items.item1')}</li>
            <li>{t('freteMachineLearning_page.sections.approach.items.item2')}</li>
            <li>{t('freteMachineLearning_page.sections.approach.items.item3')}</li>
            <li>{t('freteMachineLearning_page.sections.approach.items.item4')}</li>
            <li>{t('freteMachineLearning_page.sections.approach.items.item5')}</li>
            <li>{t('freteMachineLearning_page.sections.approach.items.item6')}</li>
            <li>{t('freteMachineLearning_page.sections.approach.items.item7')}</li>
            <li>{t('freteMachineLearning_page.sections.approach.items.item8')}</li>
          </ul>
          <hr />
          <h3>{t('freteMachineLearning_page.sections.result.title')}</h3>
          <ul>
            <li>{t('freteMachineLearning_page.sections.result.items.item1')}</li>
            <li>{t('freteMachineLearning_page.sections.result.items.item2')}</li>
            <li>{t('freteMachineLearning_page.sections.result.items.item3')}</li>
          </ul>
          {/*
          <div className="DataHashtag">
            <button>Data Engineering</button>
            <button>GEN IA</button>
            <button>Full Stack development</button>
            <button>UX</button>
          </div>
          */}
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('solutionsData_page.cases.title')}</h2>
        <span className="subtitle">{t('solutionsData_page.cases.subtitle')}</span>

        <Pagination data={casesData} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span>{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('solutionsData_page.cases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default FreteMachineLearning
